import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { angleDoubleLeft } from '@primeicons/core/angle-double-left';

@Component({
    selector: 'svg[data-p-icon="angle-double-left"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class AngleDoubleLeft extends CoreIcon {
    constructor() {
        super();
        this._icon = angleDoubleLeft;
    }
}
